import AssetsPage from "./AssetsPage";

const resources = (permissions) => (
    {
        list: AssetsPage,
        create: (permissions.includes('prambanan_manager') ? AssetsPage : undefined),
    }
)

export default resources